import React from "react";

const members = [
  {
    name: "Freskim",
    role: "Inxhinier kryesor softueri",
    bio: "Ndërton sisteme të qëndrueshme dhe të shkallëzueshme. Udhëheq projektet full-stack nga dizajni teknik deri te mbështetja pas lansimit.",
    initials: "F",
    accent: "linear-gradient(135deg, #22d3ee 0%, #6366f1 100%)",
  },
  {
    name: "Lulzim",
    role: "Dizajner kryesor i produktit",
    bio: "Krijon ndërfaqe të qarta dhe intuitive. Nga kuptimi i nevojave të klientit deri te verifikimi final para lansimit.",
    initials: "L",
    accent: "linear-gradient(135deg, #a78bfa 0%, #22d3ee 100%)",
  },
  {
    name: "Blerim",
    role: "Inxhinier senior mobile",
    bio: "Zhvillon aplikacione native për iOS dhe Android. Specializohet në publikim në App Store & Google Play dhe optimizim të performancës.",
    initials: "B",
    accent: "linear-gradient(135deg, #34d399 0%, #22d3ee 100%)",
  },
];

function Team() {
  return (
    <section className="team section-pad" id="team">
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Udhëheqja</span>
          <h2>Profesionistë seniorë në çdo angazhim</h2>
          <p>
            Punoni drejtpërdrejt me njerëzit që e bëjnë punën — jo vetëm me juniorë të mbikëqyrur. Klientët tanë na zgjedhin kur cilësia dhe afati i dorëzimit nuk mund të rrezikohen.
          </p>
        </div>

        <div className="team-grid">
          {members.map(({ name, role, bio, initials, accent }) => (
            <article key={name} className="member">
              <div
                className="member-avatar"
                style={{ background: accent }}
                aria-hidden="true"
              >
                <span className="member-initials">{initials}</span>
              </div>
              <h3>{name}</h3>
              <p className="member-role">{role}</p>
              <p className="member-bio">{bio}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Team;
